import { StudioError } from '#~/error/index.js';
import { broker } from '#~/agent/broker.js';
import type { Opaque } from 'type-fest';

export const saveRecordingPath = async (
  agentID: Opaque<string, '__agentId'>,
  recordingPath: string
): Promise<void> => {
  const proxy = broker.acquire(agentID);
  if (!proxy) {
    throw new Error('PW-79B');
  }
  const mutation = {
    control: {
      studio: {
        recordingDirectory: recordingPath
      }
    }
  };

  try {
    await proxy.mutate(mutation, {});
  } catch (cause) {
    throw new StudioError('Unable to save recording path', { cause });
  }
};
